export const CLEAR_SEARCH_RESULTS= 'CLEAR_SEARCH_RESULTS'
export const CLEAR_SEARCH_RESULTS_SUCCESS= 'CLEAR_SEARCH_RESULTS_SUCCESS'
export const CLEAR_SEARCH_RESULTS_ERROR='CLEAR_SEARCH_RESULTS_ERROR'

export const ClearSearchResults= (data) => ({
    type: CLEAR_SEARCH_RESULTS,
    payload: data
})


